// extracted by mini-css-extract-plugin
export default {"titleContainer":"App_titleContainer__Ptgcy","appStyles":"App_appStyles__CMWk8","autor":"App_autor__AAz8d"};